import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift } from 'lucide-react';

const VOUCHER_IMG =
  'https://res.cloudinary.com/ddclgpokn/image/upload/v1791544602/Atlantic-coast-tattoo-studio-newquay-Cornwall.jpg';

const VoucherTeaser = () => {
  const navigate = useNavigate();
  return (
    <section id="vouchers" className="relative py-20 bg-black" data-testid="voucher-teaser">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div
            className="relative w-full pb-[70%] overflow-hidden border border-white/10 cursor-pointer group"
            onClick={() => navigate('/shop')}
          >
            <img
              src={VOUCHER_IMG}
              alt="Atlantic Coast Tattoo gift vouchers"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div>
            <div className="flex items-center gap-3 text-white/60 text-xs tracking-[0.3em] mb-4">
              <Gift size={16} />
              GIFT VOUCHERS
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-5">
              GIVE THE GIFT OF INK
            </h2>
            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-8 max-w-md">
              Physical, individually numbered vouchers posted to your door. Redeemable against any
              tattoo or laser removal treatment at our Newquay studio.
            </p>
            <button
              data-testid="teaser-buy-vouchers-btn"
              onClick={() => navigate('/shop')}
              className="bg-white text-black px-8 py-3 text-sm tracking-widest hover:bg-gray-200 transition-colors"
            >
              BUY VOUCHERS
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VoucherTeaser;
